import { makeAutoObservable } from 'mobx'
import moment from 'moment'

class NewFilterStore<T extends Object> {
  public params: T | null = null
  public defaultValues: T | null = null
  public currentFilters: Partial<T> = {}
  public isFakeLoading = false

  constructor(defaultValues: T) {
    this.params = defaultValues
    this.defaultValues = defaultValues
    makeAutoObservable(this)
  }

  public setParams = (params: T) => {
    this.params = params
    this.isFakeLoading = true
  }

  public clear = () => {
    this.params = this.defaultValues
    this.currentFilters = {}
  }

  public deleteParam = (paramKey: keyof T) => {
    this.isFakeLoading = true

    setTimeout(() => {
      this.updateParams(paramKey)
    }, 0)
  }

  private updateParams = (paramKey: keyof T) => {
    const updatedParams = updateParamsOnDelete(
      paramKey,
      this.params!,
      this.defaultValues!,
    )

    this.setParams(updatedParams as T)
  }

  public getParams = () => {
    const newParams = {} as any

    for (const key in this.params) {
      const currentKey = key as keyof T
      if (!!this.params[currentKey]) {
        switch (key) {
          case 'phone':
            newParams['phone'] = normalizePhoneNumber(
              this.params?.[key] as string,
            )
            break
          case 'phoneNumber':
            newParams['phoneNumber'] = normalizePhoneNumber(
              this.params?.[key] as string,
            )
            break
          default:
            newParams[currentKey] = this.params[currentKey]
            break
        }
      }
    }

    if (newParams.lastMovedFrom || newParams.lastMovedTo) {
      newParams.lastMoved = `${newParams.lastMovedFrom ? moment(newParams.lastMovedFrom).format('DD.MM.YYYY') : ''}${newParams.lastMovedTo && newParams.lastMovedFrom ? ' - ' : ''}${
        newParams.lastMovedTo
          ? moment(newParams.lastMovedTo).format('DD.MM.YYYY')
          : ''
      }`
    }

    this.currentFilters = newParams

    return newParams
  }

  public setIsFakeLoading = (value: boolean) => {
    this.isFakeLoading = value
  }
}

function normalizePhoneNumber(phoneNumber: string | number) {
  return String(phoneNumber).replace(/\D/g, '')
}

const updateParamsOnDelete = <T>(
  paramKey: keyof T,
  params: T,
  defaultValues: T,
) => {
  const updatedParams = {} as any

  for (const key in params) {
    const currentKey = key as keyof T

    switch (true) {
      case key === paramKey:
        updatedParams[currentKey] = defaultValues[currentKey]
        break

      case paramKey === 'territory' && ['district', 'locality'].includes(key):
        updatedParams[currentKey] = defaultValues[currentKey]
        break

      case paramKey === 'district' && key === 'locality':
        updatedParams.locality = (defaultValues as any)?.locality
        break

      default:
        updatedParams[currentKey] = params[currentKey]
    }
  }

  return updatedParams
}

export type NewFilterStoreType<
  T extends Record<string, any> = Record<string, any>,
> = InstanceType<typeof NewFilterStore<T>>

export default NewFilterStore
